module.exports = __webpack_public_path__ + "static/img/2.5a9957e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/my/0/2.png
// module id = ACuM
// module chunks = 1